import { gql } from "@apollo/client";

const SEARCH_COMPANY = gql`
  query searchCompanyByName($name: String!) {
    searchCompanyByName(name: $name) {
      id
      name
    }
  }
`;

export { SEARCH_COMPANY };
